import { User } from '.';

export interface ProgramCountryLead {
  programCountryLeadId: number;
  programId: number;
  countryId: number;
  emailAddress: string;
  user?: User;
  isPrimary: boolean;
}

export function blankProgramCountryLead(): ProgramCountryLead {
  return {
    programCountryLeadId: 0,
    programId: 0,
    countryId: 0,
    emailAddress: '',
    isPrimary: false,
  };
}
